import React, { Component } from 'react';
import Close from 'material-ui/svg-icons/navigation/close';

class ImageModal extends Component
{

    render = () => 
    {
        let display = this.props.show ? '100%' : '0%';
        return (
            <div style={ { height: display } } className="image-overlay">
                <div className="close">
                    <Close style={ { float: 'left' } } className="icon" onClick={ this.props.onClose } />
                </div>
                <div className="image-overlay-content">
                    <img className="modal-image" src={ this.props.image } alt="" />
                </div>

            </div>
        );
    }

}

export default ImageModal;


// WEBPACK FOOTER //
// ./src/components/ImageModal.js